// extracted by mini-css-extract-plugin
export default {"container":"DetailsSection_container__p8ZMM","showAll":"DetailsSection_showAll__mDaZ4","name":"DetailsSection_name__34Slj","link":"DetailsSection_link__WLT5A"};